import { gql } from '@apollo/client'

export const GET_NEWS = gql`
  query ($query: NewsQuery!) {
    news(query: $query) {
      items {
        _id
        title
        pinned
        image {
          Key
          Location
        }
        body
      }
      totalCount
    }
  }
`

// TODO on API side create a new request to get ids
export const GET_ALL_NEWS_IDS = gql`
  query ($query: NewsQuery!) {
    news(query: $query) {
      items {
        _id
      }
    }
  }
`

export const GET_NEWS_BY_ID = gql`
  query getNewsById($id: ID!) {
    getNewsById(_id: $id) {
      _id
      title
      image {
        Key
        Location
      }
      body
    }
  }
`
